import styled from 'styled-components'
import { fadeTransitionProps } from 'src/styles/animation'
import { motion } from 'framer-motion'

const BackGroundDeem = () => {
  return <BackGroundDeemBg {...fadeTransitionProps} />
}
export default BackGroundDeem

const BackGroundDeemBg = styled(motion.div)`
  position: fixed;
  width: 100%;
  height: 100%;
  min-height: calc(var(--vh, 1vh) * 100);
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 99;
`
